import { render, staticRenderFns } from "./picker-tag.vue?vue&type=template&id=372c16d1"
import script from "./picker-tag.vue?vue&type=script&lang=js"
export * from "./picker-tag.vue?vue&type=script&lang=js"
import style0 from "./picker-tag.vue?vue&type=style&index=0&id=372c16d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports